export const convertEmbedCodeToReact = (embedCode, setUrl) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(embedCode, "text/html");
  const elements = doc.body.children;

  const convertInlineStylesToReact = (inlineStyle) => {
    const styleObject = {};
    inlineStyle.split(";").forEach((declaration) => {
      if (!declaration.trim()) return;

      const [property, value] = declaration.split(":");
      if (property && value) {
        const camelCaseProperty = property
          .trim()
          .replace(/-([a-z])/g, (_, char) => char.toUpperCase());
        styleObject[camelCaseProperty] = value.trim();
      }
    });
    return styleObject;
  };

  return Array.from(elements).map((el, index) => {
    if (el.tagName.toLowerCase() === "iframe") {
      setUrl(el.getAttribute("src"));
      return (
        <iframe
          key={index}
          src={el.getAttribute("src")}
          width={"100%"}
          height={el.getAttribute("height")}
          scrolling={el.getAttribute("scrolling")}
          frameBorder={el.getAttribute("frameborder")}
          allow={el.getAttribute("allow")}
        />
      );
    }

    const reactStyle = el.getAttribute("style")
      ? convertInlineStylesToReact(el.getAttribute("style"))
      : {};

    return (
      <div key={index} style={reactStyle}>
        {el.innerHTML}
      </div>
    );
  });
};

export const fetchSpotifyDetails = async (spotifyUrl) => {
  console.log({ spotifyUrl });

  // Determine if the URL is a track, playlist, album, episode or show
  const trackIdMatch = spotifyUrl.match(/track\/([a-zA-Z0-9]+)/);
  const playlistIdMatch = spotifyUrl.match(/playlist\/([a-zA-Z0-9]+)/);
  const albumIdMatch = spotifyUrl.match(/album\/([a-zA-Z0-9]+)/);
  const episodeIdMatch = spotifyUrl.match(/episode\/([a-zA-Z0-9]+)/);
  const showIdMatch = spotifyUrl.match(/show\/([a-zA-Z0-9]+)/);

  if (!trackIdMatch && !playlistIdMatch && !albumIdMatch && !episodeIdMatch && !showIdMatch) {
    throw new Error("Invalid Spotify URL");
  }

  const type = trackIdMatch
    ? "track"
    : playlistIdMatch
    ? "playlist"
    : albumIdMatch
    ? "album"
    : episodeIdMatch
    ? "episode"
    : "show";
  const id = trackIdMatch
    ? trackIdMatch[1]
    : playlistIdMatch
    ? playlistIdMatch[1]
    : albumIdMatch
    ? albumIdMatch[1]
    : episodeIdMatch
    ? episodeIdMatch[1]
    : showIdMatch[1];

  // Spotify API credentials (replace with your own)
  const clientId = "76d7a1591ebc4614a13d32533bd7f68b";
  const clientSecret = "7d7d0b6fb1424d47a622455feab340ca";

  // Get Access Token
  const tokenResponse = await fetch("https://accounts.spotify.com/api/token", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Basic " + btoa(`${clientId}:${clientSecret}`),
    },
    body: "grant_type=client_credentials",
  });

  if (!tokenResponse.ok) {
    throw new Error("Failed to obtain access token");
  }

  const { access_token } = await tokenResponse.json();

  // Fetch details based on the type
  const endpoint =
    type === "track"
      ? `https://api.spotify.com/v1/tracks/${id}`
      : type === "playlist"
      ? `https://api.spotify.com/v1/playlists/${id}`
      : type === "album"
      ? `https://api.spotify.com/v1/albums/${id}`
      : type === "episode"
      ? `https://api.spotify.com/v1/episodes/${id}`
      : `https://api.spotify.com/v1/shows/${id}`;

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${type} details`);
  }

  const details = await response.json();

  if (type === "track") {
    // Return track details
    return {
      type: "track",
      title: `${details?.artists[0]?.name} - ${details?.name}` || "",
      image: details?.album.images[0]?.url || null,
    };
  } else if (type === "playlist") {
    // Return playlist details
    return {
      type: "playlist",
      title: details?.name || "",
      image: details?.images[0]?.url || null,
    };
  } else if (type === "album") {
    // Return album details
    return {
      type: "album",
      title: details?.name || "",
      artist: details?.artists?.map((artist) => artist.name).join(", ") || "",
      image: details?.images[0]?.url || null,
    };
  } else if (type === "episode") {
    // Return episode details
    return {
      type: "episode",
      title: details?.name || "",
      show: details?.show?.name || "",
      image: details?.images?.[0]?.url || null,
    };
  } else if (type === "show") {
    // Return show details
    return {
      type: "show",
      title: details?.name || "",
      publisher: details?.publisher || "",
      image: details?.images?.[0]?.url || null,
    };
  }
};

export const extractSoundCloudTitle = (htmlString) => {
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Find the div and the <a> elements
  const div = doc.querySelector("div");
  const artistAnchor = div.querySelector("a:nth-child(1)");
  const trackAnchor = div.querySelector("a:nth-child(2)");

  if (artistAnchor && trackAnchor) {
    const artist = artistAnchor.title; // Extract artist title
    const track = trackAnchor.title; // Extract track title
    return `${artist} - ${track}`;
  }

  return "Title not found";
};
